import React from 'react';

import WaitingList from './WaitingList';

const ShopWaitingList = props => (
  <div className="u-p">
    <WaitingList heading="Shop waiting list" showBarber {...props} />
  </div>
);

export default ShopWaitingList;
